export default {
  data() {
    return {
      backToTop: false,
    };
  },

  mounted () {
    this.scrollHandler();
    document.addEventListener('scroll', this.scrollHandler);
  },

  destroyed () {
    document.removeEventListener('scroll', this.scrollHandler);
  },

  methods: {
    scrollHandler() {
      this.backToTop = document.body.scrollTop > 20 || document.documentElement.scrollTop > 20;
    },

    scrollBackToTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
  },
};
